'use-client';
import * as React from 'react';
import { Image as PixelPerfectImage } from '@wix/image';
import styles from './style/Image.module.scss';
import classNames from 'clsx';
const Image = props => {
    const { id, alt, role, className, imageStyles = {}, targetWidth, targetHeight, onLoad, onError, containerWidth, containerHeight, isInFirstFold, socialAttrs, skipMeasure, responsiveImageProps, zoomedImageResponsiveOverride, displayMode, } = props;
    const effectiveWidth = targetWidth || containerWidth;
    const effectiveHeight = targetHeight || containerHeight;
    const { fallbackSrc, srcset, sources, css } = responsiveImageProps || {};
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { width, height, ...responsiveImgCssNoHeightAndWidth } = responsiveImageProps?.css?.img || {};
    const responsiveImagesStyle = displayMode === 'original_size'
        ? responsiveImageProps?.css?.img
        : responsiveImgCssNoHeightAndWidth;
    if (fallbackSrc && srcset && css) {
        return (React.createElement("img", { 
            // @ts-expect-error fetchpriority type should work in react > 18.3 https://github.com/facebook/react/pull/25927
            fetchpriority: isInFirstFold ? 'high' : undefined, loading: isInFirstFold === false ? 'lazy' : undefined, sizes: `${effectiveWidth}px`, srcSet: skipMeasure
                ? zoomedImageResponsiveOverride?.srcset
                : responsiveImageProps?.srcset, id: id, src: fallbackSrc, alt: alt || '', role: role, style: {
                ...imageStyles,
                ...(skipMeasure
                    ? { ...zoomedImageResponsiveOverride?.css?.img }
                    : { ...responsiveImagesStyle }),
            }, onLoad: onLoad, onError: onError, className: classNames(className, styles.image), width: effectiveWidth, height: effectiveHeight, ...socialAttrs }));
    }
    if (fallbackSrc && sources && css) {
        return (React.createElement("picture", null,
            sources.map(({ srcset: sourceSrcset, media, sizes, }) => {
                return (React.createElement("source", { key: media, srcSet: sourceSrcset, media: media, sizes: sizes }));
            }),
            React.createElement("img", { 
                // @ts-expect-error fetchpriority type should work in react > 18.3 https://github.com/facebook/react/pull/25927
                fetchpriority: isInFirstFold ? 'high' : undefined, loading: isInFirstFold === false ? 'lazy' : undefined, id: id, src: sources[0].fallbackSrc, alt: alt || '', role: role, style: {
                    ...imageStyles,
                    objectFit: sources[0].imgStyle.objectFit,
                    objectPosition: sources[0].imgStyle.objectPosition,
                }, onLoad: onLoad, onError: onError, className: classNames(className, styles.image), width: effectiveWidth, height: effectiveHeight, ...socialAttrs })));
    }
    return React.createElement(PixelPerfectImage, { ...props });
};
export default Image;
//# sourceMappingURL=Image.js.map